import React from "react"
import FeaturesZigzagList from "./FeaturesZigzagList"

function FeaturesZigzag() {
  return (
    <section id="how-it-works">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <h2 className="h2 mb-4" data-aos="fade-up">
              Why Filmustage?
            </h2>
            <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              Discover the benefits that come with choosing our platform.
            </p>
          </div>

          {/* Items */}
          <FeaturesZigzagList />
        </div>
      </div>
    </section>
  )
}

export default FeaturesZigzag
